import React, { FC } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { IDropableItemData } from "@websential/cosmic-v20";

export interface IPayrollYearToDateAddEmployeePanel {
	firstList: {
		droppableId: string;
		elements: IDropableItemData[];
		testId: String;
	};
	secondList: {
		droppableId: string;
		elements: IDropableItemData[];
		testId: String;
	};
	onDragEnd: (result: any, _provided: any) => void;
	isLoadingAssignedEmployees: boolean;
	isPendingAssignAndUnAssign: boolean;
}

export const PayrollYearToDateAddEmployeePanel: FC<
	IPayrollYearToDateAddEmployeePanel
> = ({ firstList, secondList, onDragEnd, isLoadingAssignedEmployees, isPendingAssignAndUnAssign }) => {
	return (
		<>
			{isLoadingAssignedEmployees ? <CircularProgress
				size={24}
				data-testid="circular-progress"
			/> : isPendingAssignAndUnAssign ?
				<CircularProgress
					size={24}
					data-testid="circular-progress"
				/> : <></>}
			<Box sx={{ p: 2 }}>
				<Box sx={{ mt: 3 }}>
					<DragDropContext onDragEnd={onDragEnd}>
						<Grid container spacing={2}>
							{/* Eligible Employees */}
							<Grid size={{ xs: 12, md: 6 }}>
								<Typography
									variant="h6"
									sx={{
										display: "flex",
										alignItems: "center",
										mb: 2,
									}}
								>
									Add Employees
									<Box
										component="span"
										sx={{
											ml: 1,
											px: 1.5,
											py: 0.2,
											bgcolor: "primary.main",
											color: "#fff",
											borderRadius: "100%",
											fontSize: "0.8rem",
										}}
									>
										{firstList.elements.length}
									</Box>
								</Typography>

								<Droppable droppableId={firstList.droppableId}>
									{(provided) => (
										<Box
											ref={provided.innerRef}
											{...provided.droppableProps}
											sx={{
												minHeight: "300px",
												border: "1px solid #ddd",
												borderRadius: 2,
												p: 1,
												bgcolor: "#f9f9f9",
												maxHeight: "400px",
												overflowY: "auto",
											}}
										>
											{firstList.elements.map((item: any, index: any) => (
												<Draggable
													key={item.id}
													draggableId={item.id}
													index={index}
												>
													{(provided) => (
														<Box
															ref={provided.innerRef}
															{...provided.draggableProps}
															{...provided.dragHandleProps}
															sx={{
																bgcolor: "#fff",
																mb: 1,
																p: 1.5,
																borderRadius: 1,
																border: "1px solid #ccc",
																cursor: "grab",
																"&:hover": {
																	boxShadow: 1,
																},
															}}
														>
															{item.text}
														</Box>
													)}
												</Draggable>
											))}
											{provided.placeholder}
										</Box>
									)}
								</Droppable>
							</Grid>

							{/* Ineligible Employees */}
							<Grid size={{ xs: 12, md: 6 }}>
								<Typography
									variant="h6"
									sx={{
										display: "flex",
										alignItems: "center",
										mb: 2,
									}}
								>
									Remove Employees
									<Box
										component="span"
										sx={{
											ml: 1,
											px: 1.5,
											py: 0.2,
											bgcolor: "primary.main",
											color: "#fff",
											borderRadius: "50%",
											fontSize: "0.8rem",
										}}
									>
										{secondList.elements.length}
									</Box>
								</Typography>

								<Droppable droppableId={secondList.droppableId}>
									{(provided) => (
										<Box
											ref={provided.innerRef}
											{...provided.droppableProps}
											sx={{
												minHeight: "300px",
												border: "1px solid #ddd",
												borderRadius: 2,
												p: 1,
												bgcolor: "#f9f9f9",
												maxHeight: "400px",
												overflowY: "auto",
											}}
										>
											{secondList.elements.map((item: any, index: any) => (
												<Draggable
													key={item.id}
													draggableId={item.id}
													index={index}
												>
													{(provided) => (
														<Box
															ref={provided.innerRef}
															{...provided.draggableProps}
															{...provided.dragHandleProps}
															sx={{
																bgcolor: "#fff",
																mb: 1,
																p: 1.5,
																borderRadius: 1,
																border: "1px solid #ccc",
																cursor: "grab",
																"&:hover": {
																	boxShadow: 1,
																},
															}}
														>
															{item.text}
														</Box>
													)}
												</Draggable>
											))}
											{provided.placeholder}
										</Box>
									)}
								</Droppable>
							</Grid>
						</Grid>
					</DragDropContext>
				</Box>
			</Box>
		</>
	);
};
